module.exports = __webpack_public_path__ + "img/red_042.fc4281cb.png";